// extracted by mini-css-extract-plugin
export default {"toast":"cPuDNUAPeKg4fKbVQlyg","closeToastBtn":"pxqvIBO6jBwksnGqYQLV"};